<template>
  <div class="p-2">
    <div class="row">
      <div class="col-12">
        <h3>Título da regra</h3>
        <b-form-input v-model="rule.name" placeholder=""></b-form-input>
      </div>
    </div>

    <div class="row mt-4">
      <div class="col-12">
        <h3>Regras do período</h3>
      </div>
    </div>

    <div class="row">
      <div class="col-6">
        <label>Classificar por </label>
        <b-form-checkbox
          v-if="rule.displayOrder === 'older'"
          class="pull-right"
          name="check-button"
          switch
          value="d-1"
          v-on:change="setD1($event)"
        >
          <span style="font-size: 85%;">habilitar d-1</span>
        </b-form-checkbox>

        <b-form-select v-model="rule.displayOrder">
          <b-form-select-option value="last">Mais recente</b-form-select-option>
          <b-form-select-option value="older">Mais antigo</b-form-select-option>
        </b-form-select>
      </div>
      <div class="col-6"></div>
    </div>

    <div class="row mt-4">
      <div class="col-12">
        <h3>Regras da fila do operador</h3>
      </div>
    </div>
    <div class="row">
      <div class="col-3">
        <label>Ordem de trabalho 1</label>
        <b-form-select
          v-model="rule.ruleOrder[0]"
          :options="ruleOrderOptions"
        ></b-form-select>
      </div>

      <div class="col-3">
        <label>Ordem de trabalho 2</label>
        <b-form-select
          v-model="rule.ruleOrder[1]"
          :options="ruleOrderOptions"
        ></b-form-select>
      </div>

      <div class="col-3">
        <label>Ordem de trabalho 3</label>
        <b-form-select
          v-model="rule.ruleOrder[2]"
          :options="ruleOrderOptions"
        ></b-form-select>
      </div>

      <div class="col-3">
        <label>Ordem de trabalho 4</label>
        <b-form-select
          v-model="rule.ruleOrder[3]"
          :options="ruleOrderOptions"
        ></b-form-select>
      </div>
    </div>

    <div class="row mt-4">
      <div class="col-12">
        <h3>Escolha as ações</h3>
        <div>
          <b-button
            class="btn"
            style="
              width: 150px;
              border-radius: 0;
              border: none;
              background: transparent;
            "
            @click="viewType = 'action'"
            :style="{
              borderBottom:
                viewType === 'action' ? '2px solid #4DE594' : 'none',
              color: viewType === 'action' ? '#4DE594' : '',
            }"
            >Ação</b-button
          >
          <div
            style="
              width: 100%;
              height: 1px;
              border-bottom: solid 2px #e8e8e8;
              margin-top: -2px;
            "
          ></div>
        </div>
      </div>

      <div class="row mt-4" v-if="viewType === 'action'">
        <div class="col-12 pl-4">
          <b-button
            variant="outline-primary"
            v-b-modal.modal-actions
            class="ml-2"
          >
            Selecionar ações
            <font-awesome-icon :icon="['fas', 'plus']"
          /></b-button>
        </div>
      </div>

      <div class="col-12" v-if="viewType === 'action' && actions.length">
        <div class="row mt-4">
          <div class="col-3 pl-4">
            <h3 class="ml-4">ID</h3>
          </div>
          <div class="col-6 pl-3">
            <h3>Ação</h3>
          </div>
          <div class="col-3 text-right pr-4">
            <h3 style="margin-right: 42px;">Canal</h3>
          </div>
        </div>
        <draggable v-model="actions">
          <div class="action-list-item" v-for="(item, i) in actions" :key="i">
            <div class="row">
              <div class="col-3">
                <font-awesome-icon
                  :icon="['fas', 'bars']"
                  class="ellipsis mr-2"
                  style="cursor: grab;"
                />

                <span v-if="item.controlId"> {{ item.controlId }}</span>
              </div>
              <div class="col-6">
                <span v-if="item.name">{{ item.name }}</span>
              </div>
              <div class="col-3 text-right" v-if="item.channel">
                {{ item.channel }}
                <b-button variant="outline-danger" @click="removeAction(i)">
                  <font-awesome-icon :icon="['fas', 'trash-alt']"
                /></b-button>
              </div>
            </div>
          </div>
        </draggable>
      </div>
    </div>

    <b-modal
      id="modal-actions"
      title="Selecionar ações"
      size="lg"
      ok-only
      scrollable
      @ok="addActions"
    >
      <div class="p-4">
        <div v-if="loadingActions">
          <div v-for="i in [0, 1, 2, 3, 4, 5, 6]" :key="i">
            <idx-skeleton radius="6" height="20" class="mb-3"></idx-skeleton>
            <idx-skeleton
              radius="6"
              height="20"
              class="mb-3"
              style="width: 60%;"
            />
            <idx-skeleton
              radius="6"
              height="20"
              class="mb-3"
              style="width: 40%;"
            />
          </div>
        </div>
        <div v-else>
          <b-form-group>
            <b-form-checkbox-group
              id="item-radio"
              v-model="selectedActions"
              name="radio-options"
              multiline
            >
              <div class="row">
                <div class="col-3 pl-4">
                  <h3>ID</h3>
                </div>
                <div class="col-6 pl-3">
                  <h3>Ação</h3>
                </div>
                <div class="col-3 text-right pr-4">
                  <h3>Canal</h3>
                </div>
              </div>

              <div
                class="action-list-item"
                v-for="(item, i) in allActions"
                :key="i"
              >
                <div class="row">
                  <div class="col-3">
                    <b-form-checkbox :value="item" :checked="item.selected">{{
                      item.controlId
                    }}</b-form-checkbox>
                  </div>
                  <div class="col-6">
                    {{ item.name }}
                  </div>
                  <div class="col-3 text-right">
                    {{ item.channel }}
                  </div>
                </div>
              </div>
            </b-form-checkbox-group>
          </b-form-group>
        </div>
      </div>
    </b-modal>

    <div
      style="
        background: #ffffff;
        position: sticky;
        right: 0;
        bottom: -20px;
        padding-top: 20px;
        padding-bottom: 20px;
      "
      class="text-right"
    >
      <b-button @click="saveRule" variant="primary">Salvar alterações</b-button>
    </div>
  </div>
</template>

<script>
import draggable from 'vuedraggable';
import IdxCard from '@/components/molecules/idx-card';
import idxSkeleton from '@/components/molecules/idx-skeleton';
import swal from 'sweetalert';
import api from '../../../services/api';

export default {
  props: {
    rule: { type: Object },
  },
  components: { IdxCard, idxSkeleton, draggable },
  data() {
    return {
      loadingActions: false,
      viewType: 'action',
      selectedActions: [],
      actions: [],
      ruleOrderOptions: [
        { value: 'scheduling', text: 'Agendamento' },
        { value: 'detractors', text: 'Detratores' },
        { value: 'passives', text: 'Neutros' },
        { value: 'promoters', text: 'Promotores' },
      ],
      allActions: null,
    };
  },
  methods: {
    async saveRule() {
      if (this.rule.name !== '') {
        try {
          await api.patch(
            `/treatment/update-rule/${this.rule._id}`,
            {
              ...this.rule,
              actions: this.actions.map((a) => {
                return a._id;
              }),
            },
            {
              headers: {
                'x-access-token': this.userAuth.token,
              },
            },
          );
          swal(
            'Sucesso',
            'Regra de tratativa atualizada com sucesso!',
            'success',
          );
          this.$bvModal.hide('modal-add');
        } catch (error) {
          window.console.log(error);
        }
      }
    },
    setD1(event) {
      if (event === 'd-1') {
        this.rule.timeRule = 'd-1';
      } else {
        this.rule.timeRule = 'all';
      }
    },
    addActions() {
      this.actions = this.selectedActions;
    },
    removeAction(i) {
      this.actions.splice(i, 1);
    },
    async loadAllActions() {
      this.loadingActions = true;
      try {
        const response = await api.get('/all-actions', {
          headers: {
            'x-access-token': this.userAuth.token,
          },
        });

        this.allActions = response.data.map((a) => {
          return {
            ...a,
            selected: this.selectedActions.find((item) => item._id === a._id),
          };
        });
      } catch (error) {
        window.console.log(error);
      }
      this.loadingActions = false;
    },
  },
  async mounted() {
    this.userAuth = JSON.parse(localStorage.getItem('_indecx'));

    await this.loadAllActions();
    this.actions = this.rule.actions.map((a) => {
      return this.allActions.find((item) => item._id.toString() === a);
    });
  },
};
</script>

<style scoped>
h3 {
  font-size: 90%;
  font-weight: bold;
}
label {
  font-size: 80%;
}

.btn:focus {
  outline: none;
  box-shadow: none;
}
.btn {
  box-shadow: none !important;
}
.action-list-item {
  padding: 8px;
  border-bottom: solid 1px #cccccc;
}
</style>



// WEBPACK FOOTER //
// src/components/molecules/treatments-rules/edit.vue